import type React from "react";

import { colorsPalettes } from "@similarweb/styles";
import { CircularLoader } from "@similarweb/ui-components";

import { StyledCompetitorsLoaderSkeleton } from "./styles";

const options = {
    svg: {
        stroke: colorsPalettes.carbon[200],
        strokeWidth: "4",
        r: 21,
        cx: "50%",
        cy: "50%",
    },
    style: {
        width: 46,
        height: 46,
    },
};

export const CompetitorsLoader: React.FC = () => {
    return (
        <StyledCompetitorsLoaderSkeleton>
            <CircularLoader options={options} />
        </StyledCompetitorsLoaderSkeleton>
    );
};
